import { useContext } from 'react';

import { AdminPermission, MembershipRole, ProductFeature, UseAuthProviderReturnType } from '@localstack/types';

import { extractFeaturePartitions, hasFeatureBase } from '@localstack/services';

import { AuthGuardContext } from '~/contexts/AuthGuardContext';

export const useAuthProvider = (): UseAuthProviderReturnType => {
  const context = useContext(AuthGuardContext);

  const { roles, permissions, features, platform_admin } = context.userInfo ?? {};

  const adminPermissions = platform_admin?.permissions;

  const { featureNames, featureVariants } = extractFeaturePartitions(features ?? []);

  const can = (permission: string) =>
    (permissions ?? []).includes(permission) ||
    (roles ?? []).includes(permission) ||
    (adminPermissions ?? []).includes(permission as AdminPermission);

  const hasFeature = (feature: ProductFeature, variant?: string) =>
    hasFeatureBase(featureNames, featureVariants, feature, variant);

  const isPlatformAdmin = platform_admin != null;
  const isWorkspaceAdmin = (roles ?? []).includes(MembershipRole.ADMIN);

  return { ...context, can, hasFeature, isPlatformAdmin, isWorkspaceAdmin };
};
